var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopaba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_3496)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 2.5C16.5 1.11929 12.9183 0 8.5 0C4.08172 0 0.5 1.11929 0.5 2.5L0 6.5L0.5 16C0.5 18.7614 4.08172 20 8.5 20C10.7223 20 12.6064 19.8735 13.994 19.3024C13.5441 18.3776 13.4528 17.2683 13.8704 16.1944L15.1371 12.9373L7.36941 9.42258C6.11148 8.85338 5.55315 7.37221 6.12235 6.11428C6.69155 4.85635 8.17272 4.29803 9.43065 4.86722L16.763 8.18502L17 7L16.5 2.5ZM9.5 1.25C9.91421 1.25 10.25 1.58579 10.25 2V2.5C10.25 2.91421 9.91421 3.25 9.5 3.25C9.08579 3.25 8.75 2.91421 8.75 2.5V2C8.75 1.58579 9.08579 1.25 9.5 1.25ZM3.5 2.25C3.91421 2.25 4.25 2.58579 4.25 3V6C4.25 6.41421 3.91421 6.75 3.5 6.75C3.08579 6.75 2.75 6.41421 2.75 6V3C2.75 2.58579 3.08579 2.25 3.5 2.25ZM14 2.25C14.4142 2.25 14.75 2.58579 14.75 3V4.5C14.75 4.91421 14.4142 5.25 14 5.25C13.5858 5.25 13.25 4.91421 13.25 4.5V3C13.25 2.58579 13.5858 2.25 14 2.25ZM3 10.25C3.41421 10.25 3.75 10.5858 3.75 11V15C3.75 15.4142 3.41421 15.75 3 15.75C2.58579 15.75 2.25 15.4142 2.25 15V11C2.25 10.5858 2.58579 10.25 3 10.25ZM7 12.75C7.41421 12.75 7.75 13.0858 7.75 13.5V15.5C7.75 15.9142 7.41421 16.25 7 16.25C6.58579 16.25 6.25 15.9142 6.25 15.5V13.5C6.25 13.0858 6.58579 12.75 7 12.75ZM11 13.25C11.4142 13.25 11.75 13.5858 11.75 14V17.5C11.75 17.9142 11.4142 18.25 11 18.25C10.5858 18.25 10.25 17.9142 10.25 17.5V14C10.25 13.5858 10.5858 13.25 11 13.25Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0119 9.94407C17.2193 10.0379 17.3791 10.1937 17.4795 10.3797C16.7553 10.3868 16.0345 10.7732 15.6848 11.5388L7.98778 8.05597C7.48461 7.82829 7.26128 7.23582 7.48896 6.73265C7.71664 6.22948 8.30911 6.00615 8.81228 6.23383L17.0119 9.94407Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2686 16.738L17.034 12.1983C17.1993 11.7733 17.8007 11.7733 17.966 12.1983L19.7314 16.738C20.3418 18.3075 19.184 20 17.5 20C15.816 20 14.6582 18.3075 15.2686 16.738Z",
    fill: "#653024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_3496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopaba);
export default __webpack_public_path__ + "static/media/copaíba.a32e72e9a4dc98e8633564dd289efa85.svg";
export { ForwardRef as ReactComponent };